require('./mortgageRequestAddEmail.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classnames = require('classnames');

// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ Loans
const { okLoansComponents } = require('ok-loans');

// @ components
const ContractLoanDueInformation = okLoansComponents.contractLoanDueInformation;

// @actions
const addEmailActions = require('actions/mortgageRequest/mortgageRequestAddEmail');

// @ constants
const { EMAIL_REGEX } = require('constants/index');


class MortgageRequestAddEmail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            newEmail: '',
            newEmailInitState: '',
            isSetEmailSecondary: false,
            newEmailValid: false,
            confirm: false,
            confirmValid: false,
            confirmDisabled: true
        };

        this.firstValue = false;
        this.idExpediente = '';

        this.isValidNewEmail = this.isValidNewEmail.bind(this);
        this.handleChangeNewEmail = this.handleChangeNewEmail.bind(this);
        this.handleCollapseAddEmail = this.handleCollapseAddEmail.bind(this);
        this.handleCollapseAddEmailCancel = this.handleCollapseAddEmailCancel.bind(this);
        this.handleOnBlurNewMail = this.handleOnBlurNewMail.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.buildLabelCheckbox = this.buildLabelCheckbox.bind(this);
        this.isValidCheckbox = this.isValidCheckbox.bind(this);
    }

    componentWillMount() {
        const { immProfile, mortgageRequestState, requestAddEmail } = this.props;
        const currentListDevice = immProfile.getIn(['listaDispositivos', 'dispositivo']);
        const currentInternetDevice = currentListDevice.filter(item => item.get('tipoDispositivo').trim() === 'I');
        const currentEmail = currentInternetDevice.getIn([0, 'detalleContacto']).trim();
        const currentIdExpediente = mortgageRequestState.get('idExpediente');
        this.idExpediente = currentIdExpediente;
        this.setState({ email: currentEmail });
        requestAddEmail();
    }

    componentWillReceiveProps(nextProps) {
        const nextNewEmail = nextProps.mortgageRequestAddEmail.get('email').trim();
        if (nextNewEmail && this.state.newEmail !== nextNewEmail) {
            const setNewEmail = this.state.email !== nextNewEmail ? nextNewEmail : '';
            this.setState({
                newEmail: setNewEmail,
                newEmailInitState: setNewEmail
            });
        }
    }

    buildLabelCheckbox() {
        const addEmailPrivacy = formatText('mortgageRequestManager-addEmailPrivacy');
        const addEmailPrivacyLink = formatText('mortgageRequestManager-addEmailPrivacyLink');
        return (
            <div>
                {addEmailPrivacy}&nbsp;
                <OKLink
                    modifier="emphasize"
                    target="_blank"
                    to={formatText('mortgageRequestLinks-mortgageRequestLinks_acceptanceClause')}
                >
                    {addEmailPrivacyLink}
                </OKLink>
            </div>
        );
    }

    handleChangeNewEmail(event) {
        const { value } = event.target;
        this.setState({
            newEmail: value,
            confirmDisabled: value === this.state.newEmailInitState
        });

        if (value === this.state.newEmailInitState) {
            this.setState({
                confirm: false,
                confirmValid: false
            });
        }

        if (this.firstValue) {
            this.setState({ newEmailValid: !this.isValidNewEmail(value) });
        }
    }

    handleCheckboxChange(event) {
        const { setPrivacy } = this.props;
        this.setState({
            confirm: event.target.checked,
            confirmValid: !event.target.checked
        });
        setPrivacy(event.target.checked);
    }

    handleCollapseAddEmail() {
        if (!this.state.isSetEmailSecondary) this.setState({ isSetEmailSecondary: true });
        else this.setState({ isSetEmailSecondary: false });
    }

    handleCollapseAddEmailCancel() {
        const { setEmail, setPrivacy } = this.props;
        if (this.state.isSetEmailSecondary) this.setState({ isSetEmailSecondary: false });
        this.setState({
            newEmail: this.state.newEmailInitState,
            newEmailValid: false,
            confirm: false,
            confirmDisabled: true,
            confirmValid: false
        });
        setEmail(this.state.newEmail, false, true);
        setPrivacy(this.state.confirm);
    }

    handleOnBlurNewMail(event) {
        const { value } = event.target;
        const { setEmail, setPrivacy } = this.props;
        let isChange = value !== this.state.newEmailInitState;
        let isValid = this.isValidNewEmail(value);
        this.firstValue = true;
        this.setState({ newEmailValid: !isValid });
        setEmail(this.state.newEmail, isChange, isValid);
        setPrivacy(this.state.confirm);
    }

    isValidCheckbox() {
        this.setState({
            confirmValid: !this.state.confirm
        });
    }

    isValidNewEmail(currentValue) {
        const emailIsValid = EMAIL_REGEX.test(currentValue);
        return this.state.newEmail === '' || emailIsValid;
    }

    render() {
        const addEmailTitle = formatText('mortgageRequestManager-emailChangeTitle');
        const addEmailFormLabelPrimary = formatText('mortgageRequestManager-addEmailFormLabelPrimary');
        const addEmailFormLabelSecondary = formatText('mortgageRequestManager-addEmailFormLabelSecondary');
        const addEmailFormCancel = formatText('mortgageRequestManager-cancelLink');
        const addEmailError = formatText('mortgageRequestManager-errorMessage');
        const btnAddEmail = formatText('mortgageRequestManager-btnAddEmail');
        const saveClassNames = classnames(
            'row mortgage-request-add-email__create',
            {
                'mortgage-request-add-email__create--hidden': !this.state.isSetEmailSecondary,
            }
        );

        return (
            <ContentBox
                title={addEmailTitle}
                smallTitle={true}
                customClassName="mortgage-request-add-email"
            >
                <div className="row">
                    <div className="col-xs-12">
                        <p className="mortgage-request-manager-view__text">
                            <FormattedText value="mortgageRequestManager-emailChangeDescriptionNew" />
                        </p>
                    </div>
                    <div className="col-xs-12">
                        <InputSafe
                            label={addEmailFormLabelPrimary}
                            name="email1"
                            type="text"
                            value={this.state.email}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <OKButton
                            modifier="ghost"
                            leftIcon="icon-agregar"
                            children={btnAddEmail}
                            onClick={this.handleCollapseAddEmail}
                        />
                    </div>
                </div>
                <div className={saveClassNames}>
                    <div className="col-xs-12">
                        <InputSafe
                            label={addEmailFormLabelSecondary}
                            name="newEmail"
                            type="text"
                            value={this.state.newEmail}
                            disabled={false}
                            onChange={this.handleChangeNewEmail}
                            onBlur={this.handleOnBlurNewMail}
                            errorState={this.state.newEmailValid}
                            errorMessage={addEmailError}
                            placeholder="usuario@mail.com"
                        />
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="mortgage-request-add-email__warning">
                                    <OKMessage type="important">
                                        {formatText('mortgageRequestManager-changeEmailNoteNew')}
                                    </OKMessage>
                                </div>
                            </div>
                        </div>

                        <div className="mortgage-request-add-email__actions">
                            <div className="mortgage-request-add-email__cancel">
                                <OKButton
                                    block={false}
                                    modifier="link-ghost"
                                    onClick={this.handleCollapseAddEmailCancel}
                                >
                                    <span className="mortgage-request-add-email__text-cancel">{addEmailFormCancel}</span>
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <ContractLoanDueInformation title="gdprMortgage-title" message="gdprMortgage-message" />
                    </div>
                </div>
            </ContentBox>
        );
    }
}

MortgageRequestAddEmail.propTypes = {
    mortgageRequestAddEmail: PropTypes.object,
    immProfile: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    requestAddEmail: PropTypes.func,
    setEmail: PropTypes.func,
    setPrivacy: PropTypes.func
};

module.exports.constructor = MortgageRequestAddEmail;
module.exports.MortgageRequestAddEmail = connect(
    state => ({
        mortgageRequestAddEmail: state.mortgageRequestAddEmail,
        immProfile: state.profile,
        mortgageRequestState: state.mortgageRequestState
    }), {
        requestAddEmail: addEmailActions.requestAddEmail,
        setEmail: addEmailActions.setEmail,
        setPrivacy: addEmailActions.setPrivacy
    },
    null,
    { forwardRef: true }
)(MortgageRequestAddEmail);
